import { AuthProvider } from '@/app/auth';
import router from '@/app/routes';
import PwaUpdatePrompt from '@/components/PwaUpdatePrompt/PwaUpdatePrompt';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as JotaiProvider } from 'jotai';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <JotaiProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
            <PwaUpdatePrompt />
          </AuthProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> */}
        </QueryClientProvider>
      </JotaiProvider>
    </StrictMode>,
  );
}
